export const GET_MARKERS_LOAD_START = 'GET_MARKERS_LOAD_START';
export const GET_MARKERS_LOAD_END = 'GET_MARKERS_LOAD_END';
export const GET_OTA_MARKERS_LOAD_START = 'GET_OTA_MARKERS_LOAD_START';
export const GET_OTA_MARKERS_LOAD_END = 'GET_OTA_MARKERS_LOAD_END';
export const GET_MULTIPLE_MARKERS_CALL_LOAD_START = 'GET_MULTIPLE_MARKERS_CALL_LOAD_START';
export const GET_MULTIPLE_MARKERS_CALL_LOAD_END = 'GET_MULTIPLE_MARKERS_CALL_LOAD_END';
export const GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_START = 'GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_START';
export const GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_END = 'GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_END';
export const GET_TAILORED_REGION_MARKERS_SUCCESS = 'GET_TAILORED_REGION_MARKERS_SUCCESS';
export const GET_GRAPH_LOAD_START = 'GET_GRAPH_LOAD_START';
export const GET_GRAPH_LOAD_END = 'GET_GRAPH_LOAD_END';
export const GET_SEARCH_LOAD_START = 'GET_SEARCH_LOAD_START';
export const GET_SEARCH_LOAD_END = 'GET_SEARCH_LOAD_END';
export const GET_REVIEW_STREAM_LOAD_START = 'GET_REVIEW_STREAM_LOAD_START';
export const GET_REVIEW_STREAM_LOAD_END = 'GET_REVIEW_STREAM_LOAD_END';
export const GET_BOOKING_CHANGES_LOAD_START = 'GET_BOOKING_CHANGES_LOAD_START';
export const GET_BOOKING_CHANGES_LOAD_END = 'GET_BOOKING_CHANGES_LOAD_END';
export const GET_FILTERED_BOOKINGS_LOAD_START = 'GET_FILTERED_BOOKINGS_LOAD_START';
export const GET_FILTERED_BOOKINGS_LOAD_END = 'GET_FILTERED_BOOKINGS_LOAD_END';
export const SEARCH_CHANGE = 'SEARCH_CHANGE';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_IS_USER_ALLOWED = 'SET_IS_USER_ALLOWED';
export const GET_COMPSETS_LOAD_START = 'GET_COMPSETS_LOAD_START';
export const GET_COMPSETS_LOAD_END = 'GET_COMPSETS_LOAD_END';
export const GET_COMPSET_LOAD_START = 'GET_COMPSET_LOAD_START';
export const GET_COMPSET_LOAD_END = 'GET_COMPSET_LOAD_END';
export const GET_COMPSET_LISTING_IDS_LOAD_START = 'GET_COMPSET_LISTING_IDS_LOAD_START';
export const GET_COMPSET_LISTING_IDS_LOAD_END = 'GET_COMPSET_LISTING_IDS_LOAD_END';
export const GET_USER_AIRBNB_LISTINGS_LOAD_START = 'GET_USER_AIRBNB_LISTINGS_LOAD_START';
export const GET_USER_AIRBNB_LISTINGS_LOAD_END = 'GET_USER_AIRBNB_LISTINGS_LOAD_END';
export const GET_LISTING_PRICING_RECOMMENDATION_LOAD_START =
  'GET_LISTING_PRICING_RECOMMENDATION_LOAD_START';
export const GET_LISTING_PRICING_RECOMMENDATION_LOAD_END =
  'GET_LISTING_PRICING_RECOMMENDATION_LOAD_END';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_SEARCH_LIMIT_BOX_ALERT = 'SET_SEARCH_LIMIT_BOX_ALERT';
export const GET_BOOKING_DATA_LOAD_START = 'GET_BOOKING_DATA_LOAD_START';
export const GET_BOOKING_DATA_LOAD_END = 'GET_BOOKING_DATA_LOAD_END';
export const GET_BOOKING_MULTIPLE_MARKERS_LOAD_START = 'GET_BOOKING_MULTIPLE_MARKERS_LOAD_START';
export const GET_BOOKING_MULTIPLE_MARKERS_LOAD_END = 'GET_BOOKING_MULTIPLE_MARKERS_LOAD_END';
export const GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START =
  'GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START';
export const GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END = 'GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END';
export const SET_REV_POTENTIAL_RANGE_INVESTMENT = 'SET_REV_POTENTIAL_RANGE_INVESTMENT';
export const SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN = 'SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN';
export const EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN = 'EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN';
export const SET_BOUNDS_MAP_INSIGHTS = 'SET_BOUNDS_MAP_INSIGHTS';
export const SET_FILTERS_INSIGHTS = 'SET_FILTERS_INSIGHTS';
export const SET_FILTER_INSIGHTS_ACTIVE = 'SET_FILTER_INSIGHTS_ACTIVE';
export const SET_USER_COUNTRY_CODE = 'SET_USER_COUNTRY_CODE';
export const SET_INDIVIDUAL_REV_POTENTIAL_RANGE = 'SET_INDIVIDUAL_REV_POTENTIAL_RANGE';
export const SET_HISTORICAL_DATA = 'SET_HISTORICAL_DATA';
export const SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR = 'SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR';
export const GET_CACHED_SEARCH_MARKETS = 'GET_CACHED_SEARCH_MARKETS';
export const SET_TOP_BANNER_OPEN = 'SET_TOP_BANNER_OPEN';
export const SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE =
  'SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE';
export const SET_SEARCHED_MARKET_ESTIMATOR = 'SET_SEARCHED_MARKET_ESTIMATOR';
export const GET_MARKET_CACHED_DATA = 'GET_MARKET_CACHED_DATA';
export const SET_MARKET_CACHED_DATA = 'SET_MARKET_CACHED_DATA';
export const SET_MARKET_DASHBOARD_FILTER_DATA = 'SET_MARKET_DASHBOARD_FILTER_DATA';
export const SET_PRICE_TIERS = 'SET_PRICE_TIERS';
export const UPDATE_PRICE_TIERS = 'UPDATE_PRICE_TIERS';
export const GET_EXPLORER_MARKETS = 'GET_EXPLORER_MARKETS';
export const SET_EXPLORER_MARKETS = 'SET_EXPLORER_MARKETS';
export const GET_ADVANCED_MARKERS_LOAD_START = 'GET_ADVANCED_MARKERS_LOAD_START';
export const GET_ADVANCED_MARKERS_LOAD_END = 'GET_ADVANCED_MARKERS_LOAD_END';
export const GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_START =
  'GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_START';
export const GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_END =
  'GET_ADVANCED_MULTIPLE_MARKERS_CALL_LOAD_END';
export const GET_FUTURE_DAILY_DATA_LOAD_START = 'GET_FUTURE_DAILY_DATA_LOAD_START';
export const GET_FUTURE_DAILY_DATA_LOAD_END = 'GET_FUTURE_DAILY_DATA_LOAD_END';
export const GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_START =
  'GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_START';
export const GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_END =
  'GET_FUTURE_DAILY_DATA_MULTIPLE_CALL_LOAD_END';
export const SET_LOCKED_MARKET_DUMMY_DATA = 'SET_LOCKED_MARKET_DUMMY_DATA';
export const SET_IS_CACHED_MARKET_DATA_SAMPLE = 'SET_IS_CACHED_MARKET_DATA_SAMPLE';
export const GET_MARKET_MONTHLY_PERFORMANCE_LOAD_START =
  'GET_MARKET_MONTHLY_PERFORMANCE_LOAD_START';
export const GET_MARKET_MONTHLY_PERFORMANCE_LOAD_END = 'GET_MARKET_MONTHLY_PERFORMANCE_LOAD_END';
export const SET_LEAD_FORM_SOURCE = 'SET_LEAD_FORM_SOURCE';
export const DEDUCT_ESTIMATOR_CREDIT = 'DEDUCT_ESTIMATOR_CREDIT';
export const SET_USED_VERIFIED = 'SET_USED_VERIFIED';
export const SET_VISIBLE_LISTING_IDS = 'SET_VISIBLE_LISTING_IDS';
export const GET_VISIBLE_MAP_SUPPLY_LOAD_START = 'GET_VISIBLE_MAP_SUPPLY_LOAD_START';
export const SET_VISIBLE_MAP_SUPPLY = 'SET_VISIBLE_MAP_SUPPLY';
